
import {
    Component, Prop, Vue,
} from 'vue-property-decorator';
import { ProjectGroup } from '@/clients/omb-api';
import AlertError from '@/components/AlertError.vue';
import Api from '@/assets/ts/Api';
import OfflineActionHandler from '@/assets/ts/OfflineActionHandler';
import InputButton from '@/components/input/InputButton.vue';
import BaseDialog from './BaseDialog.vue';

@Component({
    components: {
        AlertError,
        InputButton,
        BaseDialog,
    },
})
export default class EditProjectGroupDialog extends Vue {

    @Prop({ required: true })
    private projectGroup!: ProjectGroup;

    private error: boolean = false;
    private archiving = false;

    private close() {
        this.$emit('close');
    }

    private async archiveProjectGroup() {
        if (!window.navigator.onLine) {
            OfflineActionHandler.handle('Bauvorhaben archivieren bestätigen');
            return;
        }

        try {
            this.archiving = true;
            const updated = await Api.omb.projectGroupToArchive(this.projectGroup.id ?? 0);
            this.$emit('archive', updated);
        } catch (e) {
            this.error = true;
        }
    }

    private reloadPage() {
        this.$router.go(0);
    }

}
